import { render, staticRenderFns } from "./OrderPurcharseAttentionPanel.vue?vue&type=template&id=ddc8d468&"
import script from "./OrderPurcharseAttentionPanel.vue?vue&type=script&lang=js&"
export * from "./OrderPurcharseAttentionPanel.vue?vue&type=script&lang=js&"
import style0 from "./OrderPurcharseAttentionPanel.vue?vue&type=style&index=0&id=ddc8d468&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports